<template>
    <Head :title="__('List of prices')"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('List of prices') }}
            </h2>
            <search-control v-model="search" />
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component :title="__('Price Config List')" :icon="mdiListStatus" has-table
                        :header-icon="mdiPlusBoxOutline"
                        :header-text="__('Create :resource', {resource: __('The Price').toLowerCase()})"
                        @headerIconClick="$inertia.visit(route('price-configs.create'))">
            <price-configs-table :items="priceConfigs" :languageOptions="languageOptions" :search="search" />
        </card-component>
    </BreezeDashboardLayout>
</template>

<style>
</style>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {ref, reactive, computed} from 'vue'
import {
    mdiListStatus,
    mdiPlusBoxOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import __ from '@/trans';
import PriceConfigsTable from '@/Components/Dashboard/PriceConfigsTable'
import SearchControl from '@/Components/Dashboard/SearchControl'

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons,
        PriceConfigsTable,
        SearchControl
    },
    props: {
        success: String,
        priceConfigs: Object,
        languageOptions: Array
    },
    data() {
        return {
            search: ''
        }
    },
    setup() {
        return {
            mdiListStatus,
            mdiPlusBoxOutline
        }
    }
}
</script>
